const pageNameKey = "dropArea";

export const dropAreaEn = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Upload or drag & drop",
  },
};

export const dropAreaPtBr = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Faça upload ou arraste e solte",
  },
};

export const dropAreaDe = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Hochladen oder per Drag & Drop ablegen",
  },
};

export const dropAreaZhHans = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "上传或拖放",
  },
};

export const dropAreaIt = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Carica o trascina e rilascia",
  },
};

export const dropAreaEs = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Sube o arrastra y suelta",
  },
};

export const dropAreaNl = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Uploaden of hierheen slepen en neerzetten",
  },
};

export const dropAreaTr = {
  [pageNameKey]: {
    uploadOrDragAndDropText: "Yükleyin veya sürükleyip bırakın",
  },
};
